import yiyouLogo from './label_logo/yiyou_trim.png';
import sfLogo from './label_logo/SF_logo_trim.jpeg';
import JsBarcode from 'jsbarcode';
import QRCode from 'qrcode';

const generateBarcodes = async (expressNumber, twoDimensionCode) => {
  const createBarcode = (text, options) => {
    const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

    try {
      JsBarcode(svg, text, {
        format: 'CODE128',
        xmlDocument: document,
        background: '#FFFFFF',
        lineColor: '#000000',
        ...options,
      });
    } catch (error) {
      console.error('Barcode generation error:', error);
      return '';
    }

    return svg.outerHTML;
  };

  const mainBarcode = createBarcode(expressNumber, {
    width: 2.15,
    height: 38,
    displayValue: true,
    fontSize: 13,
    textMargin: 2,
    margin: 0,
  });

  const createQrCode = async (text) => {
    if (!text) return '';

    try {
      return await QRCode.toString(text, {
        type: 'svg',
        errorCorrectionLevel: 'M',
        margin: 0,
        color: {
          dark: '#000000',
          light: '#FFFFFF',
        },
      });
    } catch (error) {
      console.error('QR code generation error:', error);
      return '';
    }
  };

  // Prefer the SF-provided two-dimensional code payload (MMM={...}) so the
  // scanned code matches what SF expects; fall back to the tracking number.
  const qrCode = await createQrCode(twoDimensionCode || expressNumber);

  return {
    mainBarcode,
    qrCode,
  };
};

const formatDateTime = (dateString) => {
  if (!dateString) return '-';

  const date = new Date(dateString);

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

const maskName = (name) => {
  if (!name) return '-';

  const str = String(name);

  if (str.length <= 1) return str;

  return `${str[0]}${'*'.repeat(Math.max(str.length - 1, 1))}`;
};

const maskPhone = (phone) => {
  if (!phone) return '-';

  const str = String(phone);

  if (str.length <= 4) return str;

  return `${str.slice(0, 2)}******${str.slice(-2)}`;
};

const generateLabel = async (item) => {
  try {
    const expressNumber = item.express_number || item.tracking_number || '';
    const twoDimensionCode = item.two_dimension_code || '';

    const { mainBarcode, qrCode } = await generateBarcodes(expressNumber, twoDimensionCode);

    if (!mainBarcode) {
      console.error('Failed to generate barcode');
      return null;
    }

    const orderDateTime = formatDateTime(item.created_at);

    const sfNumber = expressNumber ? `SF${expressNumber}` : 'SF';

    const destRouteLabel =
      item.dest_route_label ||
      item.route_label ||
      item.destination_code ||
      '-';

    return `
      <style>
        @media print {
          * {
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
            color-adjust: exact !important;
          }

          @page {
            size: 88mm 120mm;
            margin: 0;
          }

          html,
          body {
            margin: 0;
            padding: 0;
            width: 58mm;
          }
        }

        html,
        body {
          margin: 0;
          padding: 0;
        }

        .zto-label {
          position: relative;
          width: 88mm;
          min-height: 120mm;
          box-sizing: border-box;
          font-family: "SimSun", "Microsoft YaHei", Arial, sans-serif;
          background: #fff;
          color: #000;
          overflow: visible;
          margin-left: 1mm;
          margin-top: 2mm;
          transform: scale(1.1);
          transform-origin: top left;
        }

        .sf-strip {
          position: absolute;
          left: 2mm;
          top: 33.05mm;
          width: 6mm;
          height: 88.95mm;
          box-sizing: border-box;
        }

        .sf-num {
          position: absolute;
          left: 1.4mm;
          white-space: nowrap;
          font-size: 9px;
          font-weight: 700;
          letter-spacing: 0.5px;
          transform: translate(-50%, -50%) rotate(-90deg);
          transform-origin: center;
        }

        .sf-num-1 {
          top: 16%;
        }

        .sf-num-2 {
          top: 50%;
        }

        .sf-num-3 {
          top: 84%;
        }

        .label-top {
          height: 33.05mm;
          box-sizing: border-box;
          padding: 1.5mm 0 0 2mm;
        }

        .label-cell {
          border: 1px solid #000;
          box-sizing: border-box;
          margin-left: 6mm;
          width: 82mm;
        }

        .brand-row {
          height: 12mm;
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
        }

        .brand-left {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
        }

        .brand-logo {
          width: auto;
          height: 8.25mm;
          max-width: 30mm;
          margin-top: 0;
        }

        .brand-hotline {
          font-size: 8.8px;
          font-weight: 700;
          line-height: 1.2;
          margin-top: 0.5mm;
          white-space: nowrap;
        }

        .brand-service {
          font-size: 26px;
          font-weight: 900;
          letter-spacing: 2px;
          line-height: 1;
          white-space: nowrap;
          align-self: center;
        }

        .logo {
          width: 16mm;
          height: auto;
          margin-top: 1mm;
        }

        .date {
          font-size: 8px;
          font-weight: 700;
          line-height: 1.5;
          white-space: nowrap;
        }

        .route {
          height: 7mm;
          line-height: 7mm;
          text-align: center;
          font-size: 13px;
          font-weight: 900;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .route-sub {
          height: 7mm;
          line-height: 7mm;
          text-align: center;
          font-size: 13px;
          font-weight: 900;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .main-area {
          display: flex;
          height: 48.15mm;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .main-left {
          flex: 1;
          min-width: 0;
        }

        .barcode-main-row {
          height: 19.55mm;
          margin-top: 0;
          display: flex;
          box-sizing: border-box;
        }

        .barcode-main {
          flex: 1;
          padding: 0;
          box-sizing: border-box;
          overflow: hidden;
        }

        .barcode-main svg {
          width: 100%;
          height: 19.55mm;
          display: block;
        }

        .info-row {
          display: flex;
          border-bottom: 1px solid #000;
          box-sizing: border-box;
        }

        .receiver-row {
          height: 27.15mm;
        }

        .sender-row {
          height: 21mm;
          border-bottom: 0;
        }

        .row-label {
          width: 8mm;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 17px;
          font-weight: 900;
          border-right: 1px solid #000;
          box-sizing: border-box;
        }

        .row-content {
          flex: 1;
          padding: 2mm 2mm;
          box-sizing: border-box;
          font-size: 13px;
          line-height: 1.35;
          overflow: hidden;
          display: flex;
          align-items: flex-start;
        }

        .row-info {
          flex: 1;
          min-width: 0;
        }

        .qr-block {
          flex: 0 0 auto;
          width: 24mm;
          height: 23.15mm;
          margin-left: 1mm;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
        }

        .qr-block svg {
          width: 100%;
          height: 100%;
          display: block;
        }

        .name-line {
          font-size: 13px;
          font-weight: 700;
          margin-bottom: 1mm;
          white-space: nowrap;
        }

        .address-line {
          font-size: 10px;
          font-weight: 700;
          line-height: 1.35;
          word-break: break-all;
        }

        .product-row {
          height: 14.8mm;
          padding: 0 2mm 0 10px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 12px;
          overflow: hidden;
        }

        .product-row .logo {
          width: auto;
          height: 11.5mm;
          max-width: 30mm;
          margin-left: 0;
          align-self: flex-end;
          margin-bottom: 0;
        }

        .checked-info {
          text-align: right;
          font-size: 22.5px;
          font-weight: 900;
          line-height: 1.35;
          white-space: nowrap;
        }

        .bottom-row {
          height: 12mm;
          display: flex;
          align-items: flex-end;
          justify-content: space-between;
          padding: 0 2mm 1.5mm 10px;
          box-sizing: border-box;
        }

        .order-info {
          font-size: 8px;
          font-weight: 700;
          line-height: 1.5;
          white-space: nowrap;
        }
      </style>

      <div class="zto-label">
        <div class="sf-strip">
          <div class="sf-num sf-num-1">${sfNumber}</div>
          <div class="sf-num sf-num-2">${sfNumber}</div>
          <div class="sf-num sf-num-3">${sfNumber}</div>
        </div>

        <div class="label-top">
          <div class="brand-row">
            <div class="brand-left">
              <img class="brand-logo" src="${sfLogo}" alt="SF" />

              <div class="brand-hotline">客服热线：95338</div>
            </div>

            <div class="brand-service">电商标快</div>
          </div>

          <div class="barcode-main-row">
            <div class="barcode-main">
              ${mainBarcode}
            </div>
          </div>
        </div>

        <div class="label-cell">
          <div class="route">
            ${destRouteLabel}
          </div>

          <div class="route-sub">T68</div>

          <div class="main-area">
            <div class="main-left">
              <div class="info-row receiver-row">
                <div class="row-label">收</div>

                <div class="row-content">
                  <div class="row-info">
                    <div class="name-line">
                      ${maskName(item.recipient_name)}　${maskPhone(item.recipient_phone)}
                    </div>
                    <div class="address-line">
                      ${[
                        item.recipient_province,
                        item.recipient_city,
                        item.recipient_district,
                        item.recipient_address
                      ].filter(Boolean).join('') || '-'}
                    </div>
                  </div>

                  ${qrCode ? `<div class="qr-block">${qrCode}</div>` : ''}
                </div>
              </div>

              <div class="info-row sender-row">
                <div class="row-label">寄</div>

                <div class="row-content">
                  <div class="row-info">
                    <div class="name-line">
                      ${maskName(item.sender_name)}　${maskPhone(item.sender_phone)}
                    </div>

                    <div class="address-line">
                      ${item.sender_address || '-'}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="product-row">
            <img class="logo" src="${yiyouLogo}" alt="logo" />

            <div class="checked-info">
              已验视
            </div>
          </div>

          <div class="bottom-row">
            <div class="order-info">
              <div>订单编号：${item.order_number || '-'}</div>
              <div class="date">${orderDateTime}</div>
              <div>备注：${item.notes || '-'}</div>
            </div>
          </div>
        </div>
      </div>
    `;
  } catch (error) {
    console.error('Failed to generate label:', error);
    return null;
  }
};

export default generateLabel;